import { Close } from '@mui/icons-material';
import {
  Box,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import React from 'react';

interface IProps {
  /** Icon im farbigen Kreis links neben dem Titel. */
  icon: React.ReactNode;
  /** Hauptüberschrift. */
  title: string;
  /** Optionaler Untertitel; auf Mobile (xs) wird er ausgeblendet, um nicht
   *  schlecht umzubrechen. */
  subtitle?: string;
  /** Schließen-Handler — bindet den X-Button an. Wird er weggelassen, kein X. */
  onClose?: () => void;
}

/**
 * Einheitliche Header-Zeile für unsere Dialoge: Gradient-Hintergrund mit Icon-
 * Bubble, Titel + (responsive) Untertitel und einem optionalen Close-Button
 * rechts oben.
 */
export const DialogTopBar: React.FC<IProps> = ({
  icon,
  title,
  subtitle,
  onClose,
}) => {
  return (
    <DialogTitle
      sx={theme => ({
        pr: onClose ? 7 : 3,
        background: `linear-gradient(135deg, ${alpha(
          theme.palette.primary.main,
          0.08
        )} 0%, ${alpha(theme.palette.primary.main, 0.02)} 100%)`,
        borderBottom: `1px solid ${alpha(theme.palette.primary.main, 0.08)}`,
      })}
    >
      <Stack direction='row' spacing={1.5} alignItems='center'>
        <Box
          sx={theme => ({
            width: 40,
            height: 40,
            flexShrink: 0,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: alpha(theme.palette.primary.main, 0.12),
            color: theme.palette.primary.main,
          })}
        >
          {icon}
        </Box>
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography variant='h6' sx={{ fontWeight: 700, lineHeight: 1.2 }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography
              variant='caption'
              color='text.secondary'
              sx={{ display: { xs: 'none', sm: 'block' } }}
            >
              {subtitle}
            </Typography>
          )}
        </Box>
      </Stack>
      {onClose && (
        <IconButton
          onClick={onClose}
          sx={{ position: 'absolute', right: 12, top: 12 }}
          size='small'
        >
          <Close fontSize='small' />
        </IconButton>
      )}
    </DialogTitle>
  );
};
